import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';

@Injectable()

export class PermitEndpoint extends EndpointFactory {
  private readonly getPermitTypesEndpointPath: string = this.configurations.baseUrl + "/api/permitservice/getPermitTypes";
  private readonly getPermitThemesEndpointPath: string = this.configurations.baseUrl + "/api/permitservice/getPermitThemes";
  private readonly getPermitEndpointPath: string = this.configurations.baseUrl + "/api/permitservice/getPermit";
  private readonly getAllPermitsEndpointPath: string = this.configurations.baseUrl + "/api/permitservice/getAllPermits";
  private readonly getActionsTakensEndpointPath: string = this.configurations.baseUrl + "/api/permitservice/GetActionsTakens";
  private readonly getVarianceExplanationsEndpointPath: string = this.configurations.baseUrl + "/api/permitservice/GetVarianceExplanations";
  private readonly getAutomaticYesAppliedVldsEndpointPath: string = this.configurations.baseUrl + "/api/permitservice/getAutomaticYesAppliedVlds";
  private readonly getAutomaticYesEligibilityVldsEndpointPath: string = this.configurations.baseUrl + "/api/permitservice/getAutomaticYesEligibilityVlds";
  private readonly getAutomaticYesApproachVldsEndpointPath: string = this.configurations.baseUrl + "/api/permitservice/getAutomaticYesApproachVlds";
  private readonly submitPermitEndpointPath: string = this.configurations.baseUrl + "/api/permitservice/submitPermit";
  private readonly uploadPermitDocumentEndpointPath: string = "/api/permitservice/uploadPermitDocument";

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getPermitTypes<T>(): Observable<T> {
    let endpointUrl = `${this.getPermitTypesEndpointPath}`;
    return this.http.get<T>(endpointUrl);
  }

  getPermitThemes<T>(): Observable<T> {
    let endpointUrl = `${this.getPermitThemesEndpointPath}`;
    return this.http.get<T>(endpointUrl);
  }

  getActionsTakens<T>(): Observable<T> {
    let endpointUrl = `${this.getActionsTakensEndpointPath}`;
    return this.http.get<T>(endpointUrl);
  }

  getVarianceExplanations<T>(): Observable<T> {
    let endpointUrl = `${this.getVarianceExplanationsEndpointPath}`;
    return this.http.get<T>(endpointUrl);
  }

  getPermit<T>(permitID?: string): Observable<T> {
    let endpointUrl = `${this.getPermitEndpointPath}/${permitID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAllPermits<T>(userProfileID?: string, departmentId?: string, legislationID?: string, agencyID?: string): Observable<T> {
    let endpointUrl = `${this.getAllPermitsEndpointPath}/${userProfileID}/${departmentId}/${legislationID}/${agencyID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAutomaticYesEligibilityVlds<T>(): Observable<T> {
    let endpointUrl = `${this.getAutomaticYesEligibilityVldsEndpointPath}`;
    return this.http.get<T>(endpointUrl);
  }

  getAutomaticYesAppliedVlds<T>(): Observable<T> {
    let endpointUrl = `${this.getAutomaticYesAppliedVldsEndpointPath}`;
    return this.http.get<T>(endpointUrl);
  }

  getAutomaticYesApproachVlds<T>(): Observable<T> {
    let endpointUrl = `${this.getAutomaticYesApproachVldsEndpointPath}`;
    return this.http.get<T>(endpointUrl);
  }

  submitPermit<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitPermitEndpointPath}/`;
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }

  async uploadPermitDocument(formData: any) {
    let endpointUrl = `${this.uploadPermitDocumentEndpointPath}/`;
    return await this.http.post(endpointUrl, formData, { reportProgress: true, observe: 'events' }).toPromise();
  }

}
